// Utility function to handle asset paths for deployment
export const getAssetPath = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Use PUBLIC_URL for proper subdirectory deployment
    const basePath = process.env.PUBLIC_URL || '';
    
    return `${basePath}/${cleanPath}`;
};
